import {ImagePayloadBloom, ImagePayloadInstinct} from 'services';
import {PhotoDeleteReasons} from "enums/PhotoDeleteReasons";
import {UserActor} from "interfaces";

export interface PhotoPayloadInstinct {
    image: ImagePayloadInstinct[];
    isSensitive: boolean;
    key: string;
    isAiGenerated: boolean;
}

export interface PhotoPayloadFlava {
    image: ImagePayloadInstinct[];
    isSensitive: boolean;
    id: string;
    isAiGenerated: boolean;
}

export interface PhotoPayloadBloom {
    image: ImagePayloadBloom[];
    isSensitive: boolean;
    isPrivate: boolean;
    key: string;
    isAiGenerated: boolean;
}

export interface AttractivePhotoPayloadFlava {
    id: string;
    isSensitive: boolean;
    isPrivate: boolean;
    image: { height: number, url: string; width: number }[]
}

export interface PhotoPayloadSpark {
    id: string;
    isDelicate: boolean;
    isConfirmed: boolean;
    image: { h: number, url: string; w: number }[]
    isAiGenerated: boolean;
}

export const convertPhotoPayloadSparkToBloom = (photo: PhotoPayloadSpark) => {
    return {
        ...photo,
        key: photo.id,
        image: photo.image.map(i => ({height: i.h, width: i.w, link: i.url})),
        isPrivate: photo.isConfirmed,
        isSensitive: photo.isDelicate,
        isAiGenerated: photo.isAiGenerated
    } as PhotoPayloadBloom
}

export const convertAttractivePhotoPayloadFlavaToBloom = (photo: AttractivePhotoPayloadFlava) => {
    return {
        key: photo.id,
        image: photo.image.map(i => ({...i, link: i.url})),
        isPrivate: photo.isPrivate,
        isSensitive: photo.isSensitive,
        isAiGenerated: false
    } as PhotoPayloadBloom
}

export type CommonPhotoPayload = PhotoPayloadBloom | PhotoPayloadInstinct | PhotoPayloadFlava | PhotoPayloadSpark

export interface ArchivePhoto extends PhotoPayloadBloom {
    deletionReason?: PhotoDeleteReasons;
    deletedByUser?: UserActor;
}

export const toBloomPhotoPayload = (photo: CommonPhotoPayload) => {
    const photoBloom = photo as PhotoPayloadBloom;
    const photoInstinct = photo as PhotoPayloadInstinct;
    const photoFlava = photo as PhotoPayloadFlava;
    const photoSpark = photo as PhotoPayloadSpark;

    return {
        isSensitive: photoBloom?.isSensitive ?? photoInstinct?.isSensitive ?? photoFlava?.isSensitive ?? photoSpark?.isDelicate,
        isPrivate: photoBloom?.isPrivate ?? photoSpark?.isConfirmed,
        key: photoBloom?.key ?? photoInstinct?.key ?? photoFlava?.id ?? photoSpark?.id,
        image: photo.image.map((i: any) => ({...i, link: i.url})),
        isAiGenerated: photo.isAiGenerated
    }
}